export const authRegisterRoute = {
  path: "register",
  component: () => import("../views/register.vue"),
};
export const authRegisterConfirmRoute = {
  path: "register-confirm",
  component: () => import("../views/register-confirm.vue"),
};
